import { EventEdit, EventEditConfig } from "@bryntum/schedulerpro";

export const eventEditFeature = {
    //
} satisfies Partial<EventEditConfig> | EventEdit;
